/**
 * Created by ren on 09/05/2017.
 */
import uniq from 'lodash/uniq';
import * as api from '../../services/hotkey_group/api_hotkey_group';
import * as apiCommon from '../../services/apiCommon';
import * as common from '../sagasCommon';
import * as DocType from '../../constants/constant_doc_types';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { browserHistory } from 'react-router';

export function* fetchHotKeyGroupForEditSaga(feathersApp) {
    yield takeEvery('FETCH_HOTKEY_GROUP_BY_ID', callFetchHotKeyGroupForEdit, feathersApp);
}

export function* saveHotKeyGroupSaga(feathersApp) {
    yield takeEvery("SAVE_HOTKEY_GROUP", callSaveHotkeyGroup, feathersApp);
}

export function* fetchListHotkeyGroupSaga(feathersApp) {
    yield takeLatest('FETCH_LIST_HOTKEY_GROUP', callFetchListHotkeyGroup, feathersApp);
}

export function* fetchHotKeyGroupItemsSaga(feathersApp) {
    yield takeEvery("FETCH_HOTKEY_GROUP_ITEMS", callFetchHotkeyGroupItems, feathersApp);
}

export function* deleteHotkeyGroupSaga(feathersApp) {
    yield takeEvery('DELETE_HOTKEY_GROUP', callDeleteHotKeyGroup, feathersApp);
}

export function* deleteHotkeyGroupFromListSaga(feathersApp) {
    yield takeEvery('DELETE_HOTKEY_GROUP_FROM_LIST', callDeleteHotKeyGroupFromList, feathersApp);
}

function* callFetchHotKeyGroupForEdit(feathersApp, action) {
    const { tenant, user } = yield select();
    const { id, silent } = action;
    try {
        if (id) {
            yield common.showProgressDataById(silent);
            const fetchParams = { tenant, user, id };
            let doc = yield call(api.fetchHotKeyGroupById, feathersApp, fetchParams);

            if (!doc.is_class) {
                // const hotkeyGroupItems = yield call(api.fetchHotkeyGroupItemsByHotkeyGroupID, feathersApp, { tenant, user, hotKeyGroupId: id });
                // doc.items = hotkeyGroupItems.map((hotkeyGroupItem) => {
                //     return hotkeyGroupItem.item._id;
                // });
                doc.hotkey_group_item_ids = doc.hotkey_group_items.map(item => (
                    item.hotkey_group_item_id
                ));
            }

            doc.is_class = doc.is_class ? 'true' : 'false';

            yield common.doneDataById(doc);
        }
    } catch (error) {
        yield common.showErrorDataById(error);
    }
}

function* callSaveHotkeyGroup(feathersApp, action) {
    const { tenant, user } = yield select();
    const { data } = action;
    // let currentHotKeyItemIds;
    // let newHotKeyItemIds;
    try {
        const { silent } = action;
        yield common.showProgressSaveRecord(silent);

        // if (data.id) {
        //     const hotkeyGroupItems = yield call(api.fetchHotkeyGroupItemsByHotkeyGroupID, feathersApp, { tenant, user, hotKeyGroupId: data.id }) || [];

        //     currentHotKeyItemIds = hotkeyGroupItems.map((hotkeyGroupItem) => {
        //         return hotkeyGroupItem.item._id;
        //     });
        // }

        let result = yield call(api.saveHotkeyGroup, feathersApp, { tenant, user, data });

        // if (!data.is_class) {

        //     newHotKeyItemIds = data.items || [];

        //     const hotKeyGroupItems = ( data.items || [] ).map( ( item ) => {
        //         return {
        //             id: `${result.id}:${item}`,
        //             itemId: item,
        //             hotkeyGroupId: result.id
        //         };
        //     });

        //     console.log('===hotkeyGroupItems', hotKeyGroupItems);

        //     const hotKeyGroupItemsResult = yield call(api.saveHotkeyGroupItems, feathersApp, { tenant, user, data: hotKeyGroupItems });
        //     console.log("saved hotkey_group_item", hotKeyGroupItemsResult);

        //     const toBeRemovedItemIds = _.difference(currentHotKeyItemIds, newHotKeyItemIds);
        //     console.log("removing hotkey_group_items", toBeRemovedItemIds);

        //     yield toBeRemovedItemIds.map((toBeRemovedItemId) => {
        //         return call(api.deleteHotkeyGroupItem, feathersApp, { tenant, user, id: `${result.id}:${toBeRemovedItemId}` });
        //     });
        // }


        // if (data.id && data.is_class) {
        //     const params = { tenant, user, id: data.id };
        //     yield call(api.deleteHotkeyGroupItemsByHotkeyGroupId, feathersApp, params);
        // }

        yield callFetchHotKeyGroupForEdit(feathersApp, { id: result.id, silent: true });
        browserHistory.push(`/admin/hotkey/group/edit/${result.id}`);
        yield common.doneSaveRecord(result, 'Record was saved');
    } catch (e) {
        yield common.showErrorSaveRecord(e);
    }

}

function* callFetchListHotkeyGroup(feathersApp, action) {
    const { silent, filters } = action;
    yield common.showProgressListTable(silent);
    try {
        const dataParams = { 
            filters, 
            list_type: 'hotkey_group'
        };
        const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
        yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
        yield common.doneDataById();
    } catch (error) {
        yield common.showErrorListTable(error);
    }
}

function* callDeleteHotKeyGroup(feathersApp, action) {
    const result = yield deleteHotkeyGroup(feathersApp, action);
    yield delay(2000); 
    if (result) {
        browserHistory.push('/admin/hotkey/group');
    }
}

function* deleteHotkeyGroup(feathersApp, action) {
    yield put({ type: 'DELETE_RECORD_INPROGRESS' });
    try {
        const { id } = action;
        let result = null;
        if (id) {
            const state = yield select();
            const { tenant, user } = state;
            const params = { tenant, user, id };
            // const childrenHotKeyList = yield call(api.getChildrenHotKey, feathersApp, params);
            // if (childrenHotKeyList.data && childrenHotKeyList.data.length > 0) {
            //     yield put({ type: "FETCH_LIST_DATA_ERROR", error: { message: "Error deleting Hotkey, assigned to another Hotkey as parent." }, docType: DocType.HOTKEY_GROUP });
            //     yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.HOTKEY_GROUP } });
            // } else {
            //     result = yield call(api.deleteHotkeyGroup, feathersApp, params);
            //     yield call(api.deleteHotkeyGroupItemsByHotkeyGroupId, feathersApp, params);
            //     yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.HOTKEY_GROUP } });
            // }
            result = yield call(api.deleteHotkeyGroup, feathersApp, params);
            // yield call(api.deleteHotkeyGroupItemsByHotkeyGroupId, feathersApp, params);
            yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.HOTKEY_GROUP } });
        }
        return result;
    } catch (error) {
        yield put({ type: 'DELETE_RECORD_ERROR', error })
    }
}

function* callDeleteHotKeyGroupFromList(feathersApp, action) {
    const result = yield deleteHotkeyGroup(feathersApp, action);
    yield delay(2000); 
    if (result) {
        yield callFetchListHotkeyGroup(feathersApp, { silent: true });
    }
}

function* callFetchHotkeyGroupItems(feathersApp, action) {
    const state = yield select();
    const { tenant, user } = state;
    yield put({ type: "FETCH_LIST_DATA_INPROGRESS", docType: DocType.HOTKEY_GROUP_ITEM });
    try {
        const results = yield call(api.fetchHotkeyGroupItems, feathersApp, {
            tenant,
            user,
            itemId: action.itemId
        });
        console.log('callFetchHotkeyGroupItems', results);

        let hotkeyGroupIds = results.map(data => {
            return data.hotkey_group._id;
        });

        hotkeyGroupIds = uniq(hotkeyGroupIds) || [];
        const finalResults = yield call(api.fetchHotkeyGroups, feathersApp, {
            tenant, user, hotkeyGroupIds
        });
        yield put({
            type: "FETCH_LIST_DATA_DONE",
            rows: finalResults,
            docType: DocType.HOTKEY_GROUP_ITEM
        })

    } catch (error) {
        yield put({
            type: "FETCH_LIST_DATA_ERROR",
            docType: DocType.HOTKEY_GROUP_ITEM,
            error: error
        })
    }
}
